import { twMerge } from 'tailwind-merge'

import { BoxProps } from './box.type'

const Box = <E extends React.ElementType = 'div'>({ as, children, className, ref, ...props }: BoxProps<E>) => {
  const Element = as || 'div'

  return (
    <Element className={twMerge(className)} ref={ref} {...props}>
      {children}
    </Element>
  )
}

Box.displayName = 'Box'

export default Box
